module.exports = __webpack_public_path__ + "static/media/41-iveco.295f2c63.jpg";